import { createContext, useContext, useState, useEffect } from 'react';
import { apiFetch } from './config';

// Explain mode: an app-wide toggle that annotates live data with how-it-works
// explanations. This is the shallow end of the glass-box principle — every
// score should be able to show its work (the inspector is the deep end).
// Since wave 4 the system also describes itself IN the graph: `concepts` maps
// an explain key to its in-graph definition object, so popovers can link there.
const ExplainContext = createContext({ on: false, toggle: () => {}, concepts: {} });

const STORAGE_KEY = 'worldview-explain-mode';

export function ExplainProvider({ children }) {
  const [on, setOn] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });
  const [concepts, setConcepts] = useState({});

  useEffect(() => {
    apiFetch('/api/concepts')
      .then((r) => (r.ok ? r.json() : []))
      .then((list) => setConcepts(Object.fromEntries(list.map((c) => [c.key, c]))))
      .catch(() => {}); // graph links are progressive enhancement
  }, []);

  const toggle = () => {
    setOn((prev) => {
      try {
        localStorage.setItem(STORAGE_KEY, prev ? '0' : '1');
      } catch {
        // localStorage unavailable (private mode) — toggle still works for the session
      }
      return !prev;
    });
  };

  return <ExplainContext.Provider value={{ on, toggle, concepts }}>{children}</ExplainContext.Provider>;
}

export const useExplainMode = () => useContext(ExplainContext);
